export const experimentsPublicRoutesConstants = {
  root: {
    path: "/r/pc/experiments",
    href: () => "/r/pc/experiments"
  },
  shared_experiments: {
    path: "/r/pc/experiments/shared/:token",
    href: (token: string) => `/r/pc/experiments/shared/${token}`
  },
  shared_experiment: {
    path: "/r/pc/experiments/shared/:token/:experiment_id",
    href: (token: string, experiment_id: string) =>
      `/r/pc/experiments/shared/${token}/${experiment_id}`
  },
  single_shared_experiment: {
    path: "/r/pc/experiments/shared/single/:token",
    href: (token: string) => `/r/pc/experiments/shared/single/${token}`
  },
  watchtower_experiment: {
    path: "/r/pc/experiments/watchtower/:token/:id",
    href: (id: string, token: string) =>
      `/r/pc/experiments/watchtower/${token}/${id}`
  }
};
